// extracted by mini-css-extract-plugin
export default {"container":"SmallProductItemSkelletons_container__3Snzb","newItem":"SmallProductItemSkelletons_newItem__u37+Z"};